var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationState2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2414 43.4277C10.6805 43.4277 3.94056 50.2235 4.6194 58.1709L8.55776 104.005C9.16657 111.101 15.5294 116.571 23.1798 116.571H136.821C144.466 116.571 150.829 111.101 151.443 104.005L155.382 58.1709C156.066 50.2289 149.32 43.4277 140.76 43.4277H19.2414Z",
    fill: "#FFFBE4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8802 38.5478C77.6654 33.6273 84.6181 33.6273 87.4033 38.5478L132.731 118.625C135.519 123.552 132.04 129.715 126.469 129.715H35.8144C30.2439 129.715 26.7641 123.552 29.5528 118.625L74.8802 38.5478Z",
    fill: "#695200"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2734 36.5664C76.8229 32.0625 83.1752 32.0625 85.7246 36.5664L131.052 116.644C133.619 121.179 130.402 126.813 125.326 126.813H34.6719C29.5957 126.813 26.3791 121.179 28.9463 116.644L74.2734 36.5664Z",
    fill: "white",
    stroke: "#9D7B00",
    strokeWidth: 1.23167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1448 40.3268C79.0898 38.6688 81.4799 38.6688 82.425 40.3268L127.043 118.603C127.979 120.246 126.793 122.287 124.902 122.287H35.6672C33.777 122.287 32.5911 120.246 33.5272 118.603L78.1448 40.3268Z",
    fill: "#FFCD00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8574 106.534C83.5405 106.534 85.7138 108.704 85.7139 111.382V111.439C85.7139 114.117 83.5405 116.287 80.8574 116.287C78.1742 116.287 76 114.118 76 111.439V111.382C76 108.704 78.1742 106.534 80.8574 106.534ZM80.8574 63.1445C83.5404 63.1447 85.7137 65.3143 85.7139 67.9922V96.3877C85.7139 99.0657 83.5405 101.235 80.8574 101.235C78.1742 101.235 76 99.0658 76 96.3877V67.9922C76.0002 65.3142 78.1743 63.1445 80.8574 63.1445Z",
    fill: "#695200"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2852 104.534C82.9682 104.534 85.1416 106.704 85.1416 109.382V109.439C85.1416 112.117 82.9683 114.287 80.2852 114.287C77.6019 114.287 75.4277 112.118 75.4277 109.439V109.382C75.4278 106.704 77.6019 104.534 80.2852 104.534ZM80.2852 61.1445C82.9682 61.1447 85.1414 63.3143 85.1416 65.9922V94.3877C85.1416 97.0657 82.9683 99.2352 80.2852 99.2354C77.6019 99.2354 75.4277 97.0658 75.4277 94.3877V65.9922C75.4279 63.3142 77.602 61.1445 80.2852 61.1445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationState2);
export default __webpack_public_path__ + "static/media/confirmation-state-2.48e8596d5f7caab12cb8dbb12a60ef46.svg";
export { ForwardRef as ReactComponent };